/**
 * Avatar pose / style variants (matches speacher_front's `AvatarStyle`).
 */
export enum AIAvatarStyle {
    GRACEFUL_SITTING = "graceful-sitting",
    CASUAL_SITTING = "casual-sitting",
    GRACEFUL_STANDING = "graceful-standing",
    TECHNICAL_SITTING = "technical-sitting",
    TECHNICAL_STANDING = "technical-standing",
    BUSINESS = "business",
    CASUAL = "casual",
    YOUTHFULL = "youthful",
    FORMAL = "formal",
    GRACEFUL = "graceful",
    DYNAMIC = "dynamic",
    STATIC = "static"
}
